import React from 'react';
import NautilusConnector from "../Common/NautilusConnector";
import Step from "@mui/material/Step";
import {StepLabel} from "@mui/material";
import ColorlibStepIcon from "../Booking/StepIcon/StepIcon";
import Stepper from "@mui/material/Stepper";
import {makeStyles} from "@mui/styles";
import {setStep} from "../../redux/actions/stepActions";
import {useHistory, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useIsAuthenticated} from "react-auth-kit";

const useStyles = makeStyles({
    stepper: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 40,
    },
    textMobile: {
        '& $StepLabelLabel': {
            fontSize: '0.8rem'
        }
    }
});

const GuestInfoStepper = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const step = useSelector(state => state.step);
    const {booking} = useSelector(state => state.bookingForm);
    const classes = useStyles();
    const {id} = useParams();
    // const isAuth = useIsAuthenticated();

    const moveToStep = index => {
        const {url} = steps.find(s => s.index === index);
        dispatch(setStep(index));
       
        history.push(`/booking/guest/${id}${url}`);
    };

    const getSteps = () => {
        const steps = [
            {index: 1, url: '/personal-information', label: 'Personal Information'},
            {index: 2, url: '/medical-insurance', label: 'Medical Insurance'},
        ];
        if (booking?.trip?.location?.tripTypeFk !== 2) steps.push({index: 3, url: '/diving', label: 'Diving'});
        if (booking?.trip?.location?.tripTypeFk !== 2) steps.push({index: 4, url: '/park-fees', label: 'Park Fees'});
		steps.push({index: 5, url: '/extra-activities', label: 'Extra Activities'});
        return steps;
    };

    const steps = getSteps();

    return (
        <Stepper alternativeLabel activeStep={step - 1} className={classes.stepper}
                 connector={<NautilusConnector/>}>
            {steps.length > 0 && steps.map((step) => {
                return (
                    <Step key={step.index}>
                        <StepLabel StepIconComponent={ColorlibStepIcon}
                                   onClick={() => moveToStep(step.index)}
                            // completed={isCompleted(index)}
                        >
                            <span style={{fontSize: '1.4rem'}}>{step.label}</span>
                        </StepLabel>
                    </Step>
                );
            })}
        </Stepper>
    );
};

export default GuestInfoStepper;